import UsabilityTest from 'app/components/UsabilityTest/UsabilityTest';
import { useLocalStorage } from 'app/hooks/useLocalStorage';
import Survey from 'app/ui-components/Survey/Survey';
import ThankYou from 'app/ui-components/Survey/ThankYou';
import { geSurveyAbTestVariants } from 'app/utils/abiskoUtils';
import { pathNoQueryHash } from 'app/utils/urlUtil';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useQuery } from 'urql';
import SurveyQuery from './Survey.graphql';

export const SurveyData = ({ abTestVariants }) => {
    const router = useRouter();
    const url = pathNoQueryHash(router.asPath);
    const [closed, setClosed] = useLocalStorage('closedSurveys', {});
    const [participated, setParticipated] = useLocalStorage('participatedInSurveys', {});

    const closedSurveys = Object.keys(closed);
    const participatedIn = Object.keys(participated);

    const handleOnCloseSurvey = (id) => {
        const newValue = { ...closed, [id]: true };
        setClosed(newValue);
    };

    let takeSurveyTimeout;
    const handleOnTakeSurvey = (id) => {
        const newValue = { ...participated, [id]: true };
        takeSurveyTimeout = window.setTimeout(() => {
            setParticipated(newValue);
        }, 2000);
    };

    useEffect(
        () => () => {
            window.clearTimeout(takeSurveyTimeout);
        },
        [takeSurveyTimeout]
    );

    const [result] = useQuery({
        query: SurveyQuery,
        variables: {
            abTestVariants,
        },
    });

    const { data, fetching, error } = result;

    if (fetching || error) {
        return null;
    }

    if (data) {
        if (data.surveys.length === 0) {
            return null;
        }

        const surveys = data.surveys.filter((survey) => !closedSurveys.includes(survey.id));

        const participatedInSurveys = data.surveys.filter((survey) => participatedIn.includes(survey.id));

        if (surveys.length === 0) {
            return null;
        }

        const survey = surveys[0];
        const thankYouSurvey = participatedInSurveys[0];

        const isUserTest = survey.customAttributes.find((a) => a.key === 'user-test');

        const getThankYouHeading = isUserTest
            ? 'Tack så mycket för att du deltog!'
            : 'Tack så mycket för ditt svar!';
        const usabilitySurveyLink = 'https://forms.gle/gjiSz3dFThxVVcbdA';

        if (participatedInSurveys.length > 0) {
            return (
                <ThankYou
                    survey={thankYouSurvey}
                    onCloseSurvey={handleOnCloseSurvey}
                    heading={getThankYouHeading}
                    usabilitySurveyLink={isUserTest ? usabilitySurveyLink : null}
                />
            );
        }

        const currentPage = survey.customAttributes.find((customAttribute) => customAttribute.key === 'page');

        const buttonText = survey.customAttributes.find(
            (customAttribute) => customAttribute.key === 'buttonText'
        );

        if (currentPage && currentPage.value !== url) {
            return null;
        }

        const buttonTextValue = buttonText?.value ? buttonText?.value : 'Jag vill tycka till';

        if (isUserTest) {
            return (
                <UsabilityTest
                    survey={survey}
                    buttonText={buttonTextValue}
                    onTakeSurvey={handleOnTakeSurvey}
                    onCloseSurvey={handleOnCloseSurvey}
                    url={url}
                />
            );
        }

        return (
            <Survey
                survey={survey}
                buttonText={buttonTextValue}
                onTakeSurvey={handleOnTakeSurvey}
                onCloseSurvey={handleOnCloseSurvey}
            />
        );
    }

    return null;
};

const SurveyContainer = ({ abTestVariants }) => {
    const [isBrowser, setIsBrowser] = useState(false);

    useEffect(() => {
        setIsBrowser(true);
    }, []);

    if (!isBrowser || abTestVariants.length === 0) {
        return null;
    }

    return <SurveyData abTestVariants={abTestVariants} />;
};

const mapStateToProps = (state) => ({
    abTestVariants: geSurveyAbTestVariants(state),
});

export default connect(mapStateToProps)(SurveyContainer);
